import { Injectable } from '@angular/core';
import { PzModel } from '../model/pz-model';
import { Result, Winner } from '../utils/utils';

export interface Statistic {
  round: number;
  estimatedPricePlayer1: number;
  estimatedPricePlayer2: number;
  priceAmazon: number;
  differencePricePlayer1: number;
  differencePricePlayer2: number;
  winner: Winner;
  points: number;
  senfkarteUsed: boolean;
  articleUrl: string;
  articleTitle: string;
}

@Injectable({
  providedIn: 'root',
})
export class PzService {
  public game = 1;
  public model: PzModel;
  public statistics: Statistic[] = [];
  public soundOn = true;
  public maxRounds = 11;
  public startPlayer = 1;
  public passwordPriceInputMode = true;

  constructor() {}

  public initModel(): void {
    if (this.model === undefined) {
      this.model = new PzModel(0.0, 0.0, 0);
    }
  }

  public updateStatistics(
    result: Result,
    articleUrl: string,
    articleTitle: string
  ): void {
    const newStatistic: Statistic = {
      round: this.game++,
      estimatedPricePlayer1: this.model.estimatedPricePlayer1,
      estimatedPricePlayer2: this.model.estimatedPricePlayer2,
      priceAmazon: this.model.priceAmazon,
      differencePricePlayer1: result.differenceToAmazonPricePlayer1,
      differencePricePlayer2: result.differenceToAmazonPricePlayer2,
      winner: result.winner,
      points: result.points,
      senfkarteUsed: result.senfkarteUsed,
      articleUrl: articleUrl,
      articleTitle: articleTitle,
    };
    this.statistics.push(newStatistic);
  }

  public resetModel(): void {
    this.model.estimatedPricePlayer1 = 0;
    this.model.estimatedPricePlayer2 = 0;
    this.model.priceAmazon = 0;
    this.model.senfkartePlayer1 = false;
    this.model.senfkartePlayer2 = false;
    this.model.estimatedPricePlayer1_password = '';
    this.model.estimatedPricePlayer2_password = '';
  }

  public updateAmazonPrice(parsedPrice: number): void {
    this.model.priceAmazon = parsedPrice;
  }

  public updatePointsPlayer1(result: Result): void {
    this.model.pointsPlayer1 = this.model.pointsPlayer1 + result.points;
  }

  public updatePointsPlayer2(result: Result): void {
    this.model.pointsPlayer2 = this.model.pointsPlayer2 + result.points;
  }

  public setSenfkartePlayer1(): void {
    if (this.model.senfkartePlayer1Possible) {
      this.model.senfkartePlayer1 = !this.model.senfkartePlayer1;
    }
  }

  public setSenfkartePlayer2(): void {
    if (this.model.senfkartePlayer2Possible) {
      this.model.senfkartePlayer2 = !this.model.senfkartePlayer2;
    }
  }

  public isSenfkartePlayer1(): boolean {
    return this.model.senfkartePlayer1;
  }

  public isSenfkartePlayer1Possible(): boolean {
    return this.model.senfkartePlayer1Possible;
  }

  public isSenfkartePlayer2(): boolean {
    return this.model.senfkartePlayer2;
  }

  public isSenfkartePlayer2Possible(): boolean {
    return this.model.senfkartePlayer2Possible;
  }

  public mapWinner(winner: Winner): string {
    if (winner === Winner.PLAYER_1) {
      return 'Spieler 1';
    } else if (winner === Winner.PLAYER_2) {
      return 'Spieler 2';
    }
    return 'Beide';
  }

  public mapSenfkarteState(senfkarteUsed: boolean): string {
    return senfkarteUsed ? 'Ja' : 'Nein';
  }

  public isGameFinished(): boolean {
    return this.game > this.maxRounds;
  }

  public getGameWinner(): Winner {
    if (this.model.pointsPlayer1 === this.model.pointsPlayer2) {
      return Winner.BOTH;
    } else {
      return this.model.pointsPlayer1 > this.model.pointsPlayer2
        ? Winner.PLAYER_1
        : Winner.PLAYER_2;
    }
  }

  public updateCurrentPlayer() {
    if (this.startPlayer === 1) {
      this.startPlayer = 2;
    } else {
      this.startPlayer = 1;
    }
  }
}
